import { Dropdown } from 'react-bootstrap';
import { useContext } from 'react';
import { ConnectorContext } from 'shiplab-components/ConnectorManagementPanel';
import { Connector } from 'models/Connector';

type ConnectorTableActionDropdownProps = {
  connector: Connector;
};

const ConnectorTableActionDropdownItems: React.FC<ConnectorTableActionDropdownProps> = ({ connector }) => {
  const context = useContext(ConnectorContext);

  if (!context) {
    return null;
  }

  const { handleEdit, handleDelete } = context;

  return (
    <>
      <Dropdown.Item eventKey="1" onClick={() => handleEdit(connector)}>Edit</Dropdown.Item>
      <Dropdown.Item eventKey="4" className="text-danger" onClick={() => handleDelete(connector.id)}>Delete</Dropdown.Item>
    </>
  );
};

export default ConnectorTableActionDropdownItems;

